export const environment = {
  production: false,
  apiurl: 'http://localhost:8080/api/v1',
  mock: false,
  configfromdb: true,
  config: {
    product: "OmniPAS",
    customer_fullname: "Omnicard B.V.",
    customer_shortname: "dev",
    url: "",
    phone: "+31 172 520 540",
    phone2: "+31 172 520 555",
    email: "info@omnicard.nl",
    MFAemail: false,
    MFAsms: false,
    logintype : "database",
    autologin: false,
    username: "",
    password: "",
    samlConfig: {},
    surfConfig: { issuer: "https://connect.test.surfconext.nl"
                , clientId : "dev.omnicard.nl/ngx/omnime"
                , redirectUri: "https://localhost:4250/surflogin"
                , silentRefreshRedirectUri: "https://localhost:4250/silent-refresh.html"
                , logoutUrl: "https://engine.surfconext.nl/logout"
                , scope: "openid profile email"
                , loginItem: "email"
                , oidc: true
                , skipPage: false
                },
    adfsConfig: {},
    psptype: "ingenico",
    ingenico: {
      url: "https://secure.ogone.com/ncol/test/orderstandard.asp",
      orderid: "",
      pspid: "OmnicardMBOtest",
      sha_in_key: "Vh5G9kFd+mZoiGHns1@gQEEz",
      sha_out_key: "wLB0d96md@+MRKA++@l*@Bx+",
      currency: "EUR",
      bgcolor: "#F3F3F3",
      txtcolor: "#004C93",
      tblbgcolor: "#FFFFFF",
      tbltxtcolor: "#666666",
      buttonbgcolor: "#004C93",
      buttontxtcolor: "#FFFFFF",
      fonttype: "Verdana",
      pm: "iDEAL",
      homeurl: "https://localhost:4250/payment",
      accepturl: "https://localhost:4250/payment/success",
      declineurl: "https://localhost:4250/payment/decline",
      exceptionurl: "https://localhost:4250/payment/fail",
      cancelurl: "https://localhost:4250/payment/cancel"
    },
    postcode: {
      url: "https://api.postcode.eu/nl/v1/addresses/postcode/",
      key: "7TI00FUia506n1dvsCwSTV3MvP1krZAT0uKGBJKrSBJ",
      secret: "1nFvlz5iTPaVM64nUxcBaCVQpj7sH2utCPGTrCcZDMdpfThnyE"
    },
//    cardprices: { "Student": 1500, "Employee": 1000, "External employee": 1000, "default": 1250 },
    cardprices: { "Student": 1250, "Employee": 0, "External employee": 0, "default": 0 },
    languages: [
      {
        id: 1,
        LanguageCode: "nl",
        LanguageName: "Nederlands",
        Card: "pas"
      },
      {
        id: 2,
        LanguageCode: "en",
        LanguageName: "English",
        Card: "pass"
      },
    ],
    nameoncardformats: [
      { id: 1, format: "<<Initials>> <<MiddleName>> <<LastName>>" },
      { id: 2, format: "<<FirstName>> <<MiddleName>> <<LastName>>" },
      { id: 3, format: "<<LastName>>, <<FirstName>> <<MiddleName>>" }
    ],
    savephotoonserver: false,
    changepublishpermission: true,
    chargingcard: false,
    digitalcard: false,
    uploadphoto: false,
    webcam: false,
    licenseplate: false,
    nameoncard: false,
    cardpreview: true,
    cardaslink: false,
    cardresult: false,
    cardactivate: false,
    cardblock: true,
    cardhist: true,
    carddeblock: true,
    cardrequest: true,
    logoutbutton: false,
    requestnewpassword: true,
    publishPermission: true,
    scrollButtons: true,
    breadcrumbs: false,
    versioninfooter: false,
    photoResizeToWidth: 480,
    photoMiniatureWidth: 240,
    togglefont: false,
    photorequirements: true,
    firstnameonwelcome: true,
    photoAgreedNotOnFirstPage: true,
    deliveryaddress: true,
    langimage : false,
    maintainance: false,
    timeout: 180,
  },
  ssl: false
};
